import { history } from "../../../_components/_helpers/history";
import { dataProvider, config } from "../../../studentportal-sdk";
import { utilityAndConfigStore, useCourse } from "../../store/zustand";

export const Course = (props) => {
  // data provider modules
  const { asapceoApi } = dataProvider;

  // app utility and configuration store
  const { loading,setMessage, startLoading, stopALoadingProccess } =
    utilityAndConfigStore((state) => ({
      loading: state.loading,
      setMessage: state.setMessage,
      startLoading: state.startLoading,
      stopALoadingProccess: state.stopALoadingProccess,
    }));

  const {
    courseDoc,
    courseDocs,
     setCourses,
     setCourse,
     courseAction,
     setCourseAction,
    } = useCourse((state) => ({
      courseDoc:state.courseDoc,
    courseDocs:state.courseDocs,
    setCourses: state.setCourses,
    setCourse: state.setCourse,
    courseAction: state.courseAction,
    setCourseAction: state.setCourseAction
  }));



  const getAllCourse = () => {
    (async () => {
      // start loading a process
      startLoading({
        internalLoading: true,
      });

      const course = await asapceoApi.getAllCourse();

      course.status && setCourses(course.data);

      // stop loading process
      course && stopALoadingProccess();
    })();
  };
  

  const storeCourseAction = (store) => {
    localStorage.setItem('courseId', store.id)
    setCourseAction(store)
  }

  const removeCourseAction = (store) => {
    localStorage.removeItem('courseId')
    setCourseAction(store)
    // window.location.reload()
  }

  const getCourseById = (id) => {
    (async() => {
      const course = await asapceoApi.getCourseById(id)
      course.status && setCourse(course.data)
    })()
  }

  const addCourse = (data) => {
    (async() => {

      const course = await asapceoApi.addCourse(data)
       // report occured error
       course?.error 
       && setMessage({
           type: 'error',
           show: true,
           title: config.constants.authMessage.titleError,
           // description: course?.message,
           description: course?.message,
           alert: true,
           inLine: true
       });

       // report success
       course?.status
       && setMessage({
           type: 'success',
           show: true,
           title: config.constants.authMessage.titleSuccess,
           // description: course?.message,
           description: config.constants.happyReport,
           alert: true,
           inLine: true
       });


    })()

  }

  const updateCourse = (data) => {
    (async() => {

      const course = await asapceoApi.updateCourse(data)
       // report occured error
       course?.error 
       && setMessage({
           type: 'error',
           show: true,
           title: config.constants.authMessage.titleError,
           // description: course?.message,
           description: course?.message,
           alert: true,
           inLine: true
       });

       // report success
       course?.status
       && setMessage({
           type: 'success',
           show: true,
           title: config.constants.authMessage.titleSuccess,
           // description: course?.message,
           description: config.constants.happyReport,
           alert: true,
           inLine: true
       });


    })()

  }

  const deleteCourseById = () => {
    (async() => {
      const course = await asapceoApi.deleteCourseById(courseAction.id)

     // report occured error
     course?.error 
     && setMessage({
         type: 'error',
         show: true,
         title: config.constants.authMessage.titleError,
         // description: course?.message,
         description: course?.message,
         alert: true,
         inLine: true
     });

     // report success
     course?.status
     && setMessage({
         type: 'success',
         show: true,
         title: config.constants.authMessage.titleSuccess,
         // description: course?.message,
         description: config.constants.happyReport,
         alert: true,
         inLine: true
     });
    })()
  }

  

  return {
    store: {
        courseDoc,
        courseDocs,
        courseAction,
        loading
    },
    action:{
        addCourse,
        updateCourse,
        getAllCourse,
        getCourseById,
        deleteCourseById,
        setCourseAction,
        storeCourseAction,
        removeCourseAction
    },
    history,
    ...props
  }
};
